module.exports = __webpack_public_path__ + "static/media/pg-banner.2d6f8996.png";